import React, {useContext, useEffect, useState} from 'react'
import {useParams} from "@reach/router";
import {getShippingOrdersById, updateShippingOrder} from "../../services/serviceShippingOrder";
import {Card, Col, Divider, Form, Input, Row, AutoComplete, Table, Button} from "antd";
import {ShippingOrderEditContext} from "../../context/ShippingOrderContext";
import ShippingOrderStockWarehouse from "./ShippingOrderStockWarehouse";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const {Option} = AutoComplete
const {TextArea} = Input
const shipmentTypes = [
    {
        key: 'CARGO',
        text: 'KARGO'
    },
    {
        key: 'MANUEL',
        text: 'ELDEN'
    },
    {
        key: 'VEHICLE',
        text: 'ARAÇ'
    }
]

const ShippingOrderEditContainer = () => {

    const {shippingId} = useParams()
    const [form] = Form.useForm()
    const [read, setRead] = useState(false)
    const {shippingObj} = useContext(ShippingOrderEditContext)
    const [shipping, setShipping] = shippingObj

    const [, setSelectedType] = useState()
    const [tableSource, setTableSource] = useState([])
    const [bulkList, setBulkList] = useState([])
    const [loadings, setLoadings] = useState([])


    useEffect(() => {
        getShippingOrdersById(shippingId)
            .then(({data}) => {
                const bulkListInfo = data.shippingOrderContentList.map((item) => {
                    const stockId = item.stock.id
                    const warehouseId = item.warehouse.id
                    const quantity = item.quantity
                    return {
                        stock: {
                            id: stockId
                        },
                        warehouse: {
                            id: warehouseId
                        },
                        quantity: quantity,
                        so: item.id
                    }
                })
                setBulkList(bulkListInfo)
                setShipping(data)
                createTableSource(data.shippingOrderContentList)
                setRead(!read)
            })
    }, [])

    const createTableSource = (list) => {
        const sourceList = list.map((item, index) => {
            return {
                key: index,
                ...item
            }
        })
        setTableSource(sourceList)
    }
    const columns = [
        {
            title: 'Müşteri Kodu',
            dataIndex: 'customerStockCode',
            key: 'customerStockCode',
            render: (t, r) => <Input defaultValue={t} onKeyUp={(event) => handleStockCode(event, r)}/>
        },
        {
            title: 'Stok',
            dataIndex: 'stock',
            key: 'stock',
            render: (t, r) => r.stock.description
        },
        {
            title: 'Fiyat',
            dataIndex: 'price',
            key: 'price',
            render: (t, r) => `${t.toFixed(2)} ${r.stock.currency}`
        },
        {
            title: 'Adet',
            dataIndex: 'quantity'
        }
    ]
    const changeShippingInfos = (key, val) => {
        let mock = Object.assign({}, shipping)
        mock[key] = val
        setShipping(mock)
    }
    const handleBulkList = (stockId, key, value, index) => {
        const mockList = bulkList
        const matchedItem = mockList.find(item => item.stock.id === stockId)

        if (matchedItem && key === 'warehouse' && value.id) {
            matchedItem.warehouse = value
            setBulkList([...mockList])
            return
        }

        if (matchedItem && key === 'quantity' && Number(value)) {
            matchedItem.quantity = value
            setBulkList([...mockList])
            return
        }

        if (matchedItem && (!Number(value) || !value)) {
            mockList.splice(mockList.indexOf(matchedItem), 1)
            form.setFieldsValue({
                [`warehouse-${stockId}-${index}`]: '',
                [`quantity-${stockId}-${index}`]: ''
            })
            setBulkList([...mockList])
            return
        }

        mockList.push({
            stock: {
                id: stockId
            },
            [key]: value
        })
        setBulkList([...mockList])
    }
    const handleStockCode = (event, record) => {
        let mock = Object.assign({}, shipping)
        mock.shippingOrderContentList[record.key].customerStockCode = event.target.value
        setShipping(mock)
    }
    const handleTypeChange = (v, o) => {
        let mock = Object.assign({}, shipping)
        mock.shippingType = o.key
        setShipping(mock)
        setSelectedType(o.key)
    }
    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        let mock = Object.assign({}, shipping)
        let mockStocks = []
        bulkList.forEach(bulkItem => {
            const originalStock = shipping.shippingOrderContentList.find(item => item.id === bulkItem.so)
            if (originalStock && Object.values(bulkItem).length === 4) {
                mockStocks.push({
                    ...originalStock,
                    warehouse: {id: bulkItem.warehouse.id},
                    quantity: bulkItem.quantity
                })
            }
        })
        mock.shippingOrderContentList = [...mockStocks]

        updateShippingOrder(mock)
            .then(() => {
                exitLoadingState(setLoadings)
                setTimeout(() => window.location = '/landing/shipping-order/list', 500)
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    const getProperShipping = (val) => {
        for (let i = 0; i < shipmentTypes.length; i++) {
            if (shipmentTypes[i].key === val)
                return shipmentTypes[i].text
        }
    }
    const getProperType = (val) => {
        if (val === 'SHIPMENT')
            return 'Sevkiyat'
    }
    const handleNoteChange = ({target}) => changeShippingInfos('note', target.value)
    const handleCustomerOrderChange = ({target}) => changeShippingInfos('customerOrderNo', target.value)

    return (
        <React.Fragment>
            {
                read ?
                    <Card
                        title={'Sevk Bilgileri'}
                        extra={
                            <Button
                                type={'primary'}
                                loading={loadings[0]}
                                onClick={() => form.submit()}
                            >
                                Kaydet
                            </Button>
                        }
                    >
                        <div>
                            <Form
                                form={form}
                                labelCol={{span: 8}}
                                wrapperCol={{span: 16}}
                                labelAlign={"left"}
                                onFinish={handleSubmit}
                            >
                                <Row justify={"space-between"}>
                                    <Col span={11}>
                                        <Form.Item
                                            name={'customer'}
                                            label={<span className={'font-bold'}>Müşteri</span>}
                                        >
                                            <span>{shipping.customer.code}</span>
                                        </Form.Item>
                                        <Form.Item
                                            name={'customerAddr'}
                                            label={<span className={'font-bold'}>Müşteri Adresi</span>}
                                        >
                                            <span>{shipping.customerAddress.address}</span>
                                        </Form.Item>
                                        <Form.Item
                                            name={'dispatchType'}
                                            label={<span className={'font-bold'}>İrsaliye Tipi</span>}
                                        >
                                            <span>{getProperType(shipping.dispatchType)}</span>
                                        </Form.Item>
                                        <Form.Item
                                            name={'dispatchNo'}
                                            label={<span className={'font-bold'}>İrsalliye No</span>}
                                        >
                                            <span>{shipping.dispatchNo}</span>
                                        </Form.Item>
                                        <Form.Item
                                            name={'shipmentStatus'}
                                            label={<span className={'font-bold'}>Sevk Durumu</span>}
                                        >
                                            <span>{
                                                shipping.shipmentStatus === 'WAITING' ? 'BEKLİYOR' : 'TAMAMLANDI'
                                            }</span>
                                        </Form.Item>
                                    </Col>
                                    <Col span={11}>
                                        <Form.Item
                                            name={'customerOrderNo'}
                                            label={<span className={'font-bold'}>Müşteri Sipariş No</span>}
                                            initialValue={shipping.customerOrderNo}
                                        >
                                            <Input onBlur={handleCustomerOrderChange}/>
                                        </Form.Item>
                                        <Form.Item
                                            name={'shipType'}
                                            label={<span className={'font-bold'}>Nakliye Tipi</span>}
                                            initialValue={getProperShipping(shipping.shippingType)}
                                        >
                                            <AutoComplete
                                                onChange={handleTypeChange}
                                            >
                                                {
                                                    shipmentTypes.map(item => {
                                                        return <Option key={item.key}
                                                                       value={item.text}>{item.text}</Option>
                                                    })
                                                }
                                            </AutoComplete>
                                        </Form.Item>
                                        <Form.Item
                                            name={'note'}
                                            label={<span className={'font-bold'}>Not</span>}
                                            initialValue={shipping.note}
                                        >
                                            <TextArea onBlur={handleNoteChange} />
                                        </Form.Item>
                                        <Form.Item
                                            name={'bidStatus'}
                                            label={<span className={'font-bold'}>Teklif</span>}
                                        >
                                            <span>{
                                                shipping.bid.bidStatus === 'NEGATIVE' ? 'OLUMSUZ' :
                                                    shipping.bid.bidStatus === 'WAITING' ? 'BEKLİYOR' : 'OLUMLU'
                                            }</span>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Divider/>
                                <Row>
                                    <Col span={16}>
                                        {
                                            shipping.bid.contentOfBidList.map((item, index) => {
                                                if (item.bidStatus === 'POSITIVE') {
                                                    return <ShippingOrderStockWarehouse
                                                        key={index}
                                                        index={index}
                                                        formInstance={form}
                                                        itemInfo={shipping.shippingOrderContentList[index]}
                                                        handler={handleBulkList}
                                                        stockId={item.stock.id}
                                                        stockLabel={`${item.stock.code} - ${item.stock.name}`}
                                                    />
                                                }
                                            })
                                        }
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        <Divider/>
                        <div>
                            <Table scroll={{x: 'max-content'}} columns={columns} dataSource={tableSource}/>
                        </div>
                    </Card>
                    : <span>Yükleniyor</span>
            }
        </React.Fragment>
    )
}
export default ShippingOrderEditContainer